'use strict'

setSiteCookies = require '../../../../core/frontend/groupon_modules/setSiteCookies'
tracky = require '../../../../src/frontend/helper/general/m_trackEvent'
{ setPictureSources } = require '../../../../src/frontend/helper/general/m_setPictureSources'

{ isObject } = require '../../../../src/frontend/helper/general/m_underscore_replacements'

###*
# Determine if modal was shown in current division
#
# @param   {String}  currentDivision
# @param   {String}  namespace       - Current storage / cookie name
# @returns {Boolean}
###
wasShown = (currentDivision, namespace) ->
  return true if not currentDivision
  try
    divisionMap = JSON.parse(localStorage?.getItem(namespace) or Cookie.get(namespace) or '{}')
    return !!divisionMap[currentDivision]
  catch
    return false

###*
# Update & set payload
#
# @param   {String} currentDivision
# @param   {String} namespace       - Current storage / cookie name
# @returns {String}                 - Stringified payload
###
setPayload = (currentDivision, namespace) ->
  payload =
    try
      JSON.parse(localStorage?.getItem(namespace) or Cookie.get(namespace) or '{}')
    catch
      {}

  if not isObject(payload)
    payload = {}

  payload[currentDivision] = true

  JSON.stringify(payload)

###
#  LS-3374 - GTG (GrouponToGo) modal shared code across desktop / touch / m2016
###
cloModal =
  init: ->
    namespace = 'gtg_modal'
    currentDivision = Groupon.division?.id or ''
    links = Groupon.LS.data?.cloModal?.images
    return if wasShown(currentDivision, namespace)
    return if not ($modal = $('#ls-gtg-modal')).length

    return if not (links && links.length)

    $wrapper = $('#ls-modals-wrapper')
    $html = $('html')
    $modalAndWrapper = $wrapper.add($modal)
    picture = '<picture id="ls-gtg-image"><img class="ls-gtg-teaser"/></picture>'
    $picture = $(picture)
    alt_image = Groupon.LS.translations.myStuff.gtg.image_alt
    cb = ->
      $modalAndWrapper.removeClass('ls-hide')
      $html.addClass('blockContentScrolling')
    setPictureSources($picture, links, $modal, alt_image, cb)

    $modal.on 'click', (e) ->
      e.preventDefault()
      e.stopImmediatePropagation()


    $redirectBtn = $('.ls-gtg-redirect')
    usr = Cookie.get('snickerdoodle') or ''
    patchedHref = $redirectBtn.attr('href')
      .replace(/{division}/g, Groupon.division.id)
      .replace(/{user}/g, usr)
    $redirectBtn.attr('href', patchedHref)

    $wrapper.add('.ls-gtg-content a').one 'click', (e) ->
      bhw = $(e.currentTarget).data('bhw')
      if bhw isnt 'closignup'
        bhw = 'clonothanks'
      tracky bhw
      $modal.off 'click'
      e.stopImmediatePropagation()

      payload = setPayload(currentDivision, namespace)
      if localStorage
        localStorage?.setItem(namespace, payload)
      else
        cookie = {}
        cookie[namespace] = payload
        setSiteCookies(cookie, 60 * 60 * 24 * 30) # valid for a month
      $modalAndWrapper.addClass('ls-hide')
      $html.removeClass('blockContentScrolling')

module.exports = {
  cloModal
  setPayload
  wasShown
}



// WEBPACK FOOTER //
// ./modules/shared/modals/frontend/clo-modal.coffee